/** "14:02:37" — hora local, para la línea de tiempo. */
export function hora(iso: string): string {
    return new Date(iso).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
}

/** "12 jul, 14:02" — fecha y hora local, compacta. */
export function fechaHora(iso: string): string {
    return new Date(iso).toLocaleString('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
}

/** "13 de noviembre de 2026 a las 18:05" — caducidad y similares, hora local. */
export function fechaHoraLarga(iso: string): string {
    const d = new Date(iso)
    if (Number.isNaN(d.getTime())) return iso
    const fecha = d.toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    })
    const horaLarga = d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })
    return `${fecha} a las ${horaLarga}`
}

/**
 * «jueves 17 de septiembre» — el día, sin zona.
 * La fecha llega como `YYYY-MM-DD`; no se pasa por UTC o el día se mueve.
 */
export function diaDeLaFecha(fecha: string): string {
    const partes = fecha.split('-').map(Number)
    const y = partes[0]
    const m = partes[1]
    const d = partes[2]
    if (!y || !m || !d) return fecha
    return new Date(y, m - 1, d)
        .toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })
        .replace(',', '')
}

/** Primera letra en mayúscula, para un encabezado. */
export function titular(texto: string): string {
    if (texto.length === 0) return texto
    return texto.charAt(0).toUpperCase() + texto.slice(1)
}

/**
 * «jueves 10 de septiembre a las 9» — el día de la cita, sin zona.
 * La fecha llega como `YYYY-MM-DD` del diario; no se pasa por UTC
 * o el día se mueve.
 */
export function cuandoCita(fecha: string, hora: string): string {
    const dia = diaDeLaFecha(fecha)
    if (dia === fecha) return `${fecha} a las ${hora}`
    const [hh, mm] = hora.split(':')
    const h = Number(hh)
    if (!Number.isFinite(h)) return `${dia} a las ${hora}`
    const horaCorta = !mm || mm === '00' ? String(h) : `${h}:${mm}`
    return `${dia} a las ${horaCorta}`
}

/** "hace 3 s", "hace 2 min", "hace 1 h". Corto, para la columna de última observación. */
export function haceCuanto(iso: string, ahora: number = Date.now()): string {
    const seg = Math.max(0, Math.round((ahora - new Date(iso).getTime()) / 1000))
    if (seg < 60) return `hace ${seg} s`
    const min = Math.round(seg / 60)
    if (min < 60) return `hace ${min} min`
    const h = Math.round(min / 60)
    if (h < 24) return `hace ${h} h`
    return `hace ${Math.round(h / 24)} d`
}
